import request from "@/utils/request";


//充值明细
export function queryShopChargeList(params) {
  return request({
    url: "/api/system/shopCharge/queryShopChargeList",
    method: "post",
    data: params
  });
}
//微信充值
export function wxPayBalance(params) {
  return request({
    url: "/api/system/wxPayBalance/wxPayBalance",
    method: "post",
    data: params
  });
}
//充值回调
export function queryBalance(params) {
  return request({
    url: "/api/system/wxPayBalance/queryBalance",
    method: "post",
    data: params
  });
}
//消费记录
export function queryConsumRecordList(params) {
  return request({
    url: "/api/system/consumRecord/queryConsumRecordList",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/mine/reCharge.js